exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titulo[data-v-1a53fe50]{padding-top:30px}.imagen[data-v-1a53fe50]{border-radius:6px;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);margin-top:30px}.box[data-v-1a53fe50],.time[data-v-1a53fe50]{margin-top:30px}.icon-lista[data-v-1a53fe50]{vertical-align:bottom}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a53fe50","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/informes/Subitem.vue
// module id = 723
// module chunks = 2